import * as React from 'react';
import { CarouselProvider as CarouselProvider$1, Slider } from 'pure-react-carousel';
import { CarouselButtonBack } from './CarouselButtonBack/CarouselButtonBack.esm.js';
import { CarouselButtonNext } from './CarouselButtonNext/CarouselButtonNext.esm.js';
import { CarouselControlIndicator } from './CarouselControlIndicator/CarouselControlIndicator.esm.js';
import styles from './CarouselProvider.module.esm.js';

var CarouselProvider = function (_a) {
    var carouselId = _a.carouselId, accessibleHeading = _a.accessibleHeading, items = _a.items, children = _a.children, showDots = _a.showDots, theme = _a.theme;
    var carouselSkipId = "carouselSkip_".concat(carouselId);
    var carouselNavigationId = "carouselNavId_".concat(carouselId);
    var carouselItemId = "carouselItemId_".concat(carouselId);
    return (React.createElement(React.Fragment, null,
        React.createElement("a", { className: styles.visuallyHidden, href: "#".concat(carouselSkipId) }, "".concat(accessibleHeading, " carousel, click to skip carousel")),
        React.createElement(CarouselProvider$1, { className: theme, dragEnabled: false, infinite: true, isIntrinsicHeight: true, naturalSlideHeight: 0, naturalSlideWidth: 0, totalSlides: items.length },
            React.createElement(CarouselButtonBack, null),
            React.createElement(Slider, null, children),
            React.createElement(CarouselButtonNext, null),
            showDots && (React.createElement("ul", { "aria-roledescription": "Carousel navigation", className: styles.controls, "data-testId": "dots-group", id: carouselNavigationId }, items.map(function (item, index) {
                return (React.createElement(CarouselControlIndicator, { carouselItemId: "".concat(carouselItemId, "_").concat(index), carouselSkipId: carouselSkipId, index: index, key: item.sys.id }));
            })))),
        React.createElement("div", { "aria-roledescription": "After ".concat(accessibleHeading, " carousel"), id: carouselSkipId })));
};

export { CarouselProvider as default };
//# sourceMappingURL=CarouselProvider.esm.js.map
